//
// image-service.js
//
// Copyright (c) 2015 by Curalate, Inc.
//

/*global angular: false, _: false */

(function() {
    'use strict';

    var curalate = angular.module('curalate');

    curalate.service('ImageService', ['$http', '$q', 'PromiseService', 'RestBaseUrl',
        function($http, $q, PromiseService, RestBaseUrl) {

            this.CROPPED_SQUARE_THUMBNAIL = "350x350";

            this.smartCrop = function(imageUrl, dimensions, makePubliclyReadable) {
                return PromiseService.processHttpResponse($http.post(RestBaseUrl + '/crop', {
                    imageUrl: imageUrl,
                    dimensions: dimensions,
                    makePubliclyReadable: makePubliclyReadable
                }));
            };

            this.getContentType = function(imageUrl) {
                var params = {
                    imageUrl: imageUrl
                };
                return PromiseService.processHttpResponse($http.get(RestBaseUrl + '/imageType', {params: params}));
            };

            this.getFileSize = function(imageUrl) {
                var params = {
                    imageUrl: imageUrl
                };
                return PromiseService.processHttpResponse($http.get(RestBaseUrl + '/imageSize', {params: params}));
            };

            this.getBeautifyImage = function(fileId) {
                var params = {
                    fileId: fileId
                };
                return PromiseService.processHttpResponse($http.get(RestBaseUrl + '/beautify-image-url', {params: params}));
            };

        }
    ]);

})();
